import React, { useState, useEffect } from 'react';
import t from '~t';
import Api from '~data/modules/api';

import { Layout, Alert, Button, Icon, Preloader } from '~ui';

export default function SettingsProFree() {
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState('');
  const [pricing, setPricing] = useState(null);

  useEffect(() => {
    Api._get('billing/pricing').then(setPricing).catch(() => {});
  }, []);

  const upgrade = async () => {
    if (loading || (pricing && !pricing.enabled)) return;
    setLoading(true);
    setError('');
    try {
      const { url } = await Api._post('billing/checkout');
      if (url) window.location.href = url;
      else setError('Checkout unavailable');
    } catch (e) {
      setError(
        e.errorMessage || e.message || 'Billing is not configured yet',
      );
    } finally {
      setLoading(false);
    }
  };

  return (
    <Layout>
      <Alert>
        <b>{t.s('upgradeToPro')}</b>
        <br />
        AI-powered bookmark suggestions, permanent copies, and more —
        powered by Paddle billing.
      </Alert>
      <br />

      {pricing?.price && (
        <p className='my-2 mb-4 text-[length:0.55rem] font-semibold'>
          {pricing.price}
        </p>
      )}

      <Button
        className='w-full'
        onClick={upgrade}
        disabled={loading || (pricing && !pricing.enabled)}
      >
        {loading ? <Preloader /> : <Icon name='vip' size='micro' />}
        {t.s('upgradeToPro')}
      </Button>

      {pricing && !pricing.enabled && (
        <Alert variant='warning'>
          Billing is not configured on this instance yet.
        </Alert>
      )}

      {error ? <Alert variant='warning'>{error}</Alert> : null}
    </Layout>
  );
}
